import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonProps } from '@kcftech/design-system';

export type CreateButtonProps = ButtonProps;

export function CreateButton(props: CreateButtonProps) {
    return (
        <Button
            appearance="primary"
            spacing="medium"
            icon={<FontAwesomeIcon icon={faPlus} />}
            {...props}
        >
            Create
        </Button>
    );
}
